import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const DiscountActivityManage: AppRouteModule = {
  path: '/discountActivityManage',
  name: 'DiscountActivityManage',
  identify: 'discountActivityManage',
  component: LAYOUT,
  redirect: '/discountActivityManage/discountActivity',
  meta: {
    icon: 'healthicons:money-bag-outline',
    title: '优惠活动管理',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    // 优惠活动
    {
      path: 'discountActivity',
      name: 'DiscountActivity',
      component: () => import('@/views/discountActivityManage/discountActivity/index.vue'),
      identify: 'discountActivity',
      meta: {
        title: '优惠活动',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'discountActivity/add',
      name: 'discountActivityAdd',
      identify: 'discountActivity',
      component: () => import('@/views/discountActivityManage/discountActivity/add.vue'),
      meta: {
        title: '新建优惠活动',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/discountActivityManage/discountActivity',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'discountActivity/edit',
      name: 'discountActivityEdit',
      identify: 'discountActivity',
      component: () => import('@/views/discountActivityManage/discountActivity/edit.vue'),
      meta: {
        title: '编辑优惠活动',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/discountActivityManage/discountActivity',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'discountActivity/detail',
      name: 'discountActivityDetail',
      identify: 'discountActivityManage',
      component: () => import('@/views/discountActivityManage/discountActivity/details.vue'),
      meta: {
        title: '查看优惠活动',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/discountActivityManage/discountActivity',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'discountCoupon',
      name: 'DiscountCoupon',
      component: () => import('@/views/discountActivityManage/coupon/index.vue'),
      identify: 'discountCoupon',
      meta: {
        title: '优惠管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};
export default DiscountActivityManage;
